import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';

import { DeviceDocumentFirestoreResponse } from '../../types';
import { fetchDocumentById } from '../utils';

const COLLECTION_PATH = 'pods';

export const useGetDeviceDocumentFromFirestore = (
  documentId: string | null | undefined,
  options?: UseQueryOptions<DeviceDocumentFirestoreResponse | null, FirebaseError>,
): UseQueryResult<DeviceDocumentFirestoreResponse | null, FirebaseError> => useQuery<
    DeviceDocumentFirestoreResponse | null, FirebaseError>({
      queryKey: [COLLECTION_PATH, documentId] as const,
      queryFn: async (): Promise<DeviceDocumentFirestoreResponse | null> => {
        const data = await fetchDocumentById<DeviceDocumentFirestoreResponse>(COLLECTION_PATH, documentId);
        return data
          ? {
            id: data.id,
            name: data.name,
            serial_id: data.serial_id,
            model: data.model,
            webView: data.webView,
            homeScreenWelcomeText: data.homeScreenWelcomeText,
            homeScreenImg: data.homeScreenImg,
            surveyId: !!data.surveyId,
            settings: data.settings,
            associated_organization: data.associated_organization,
            externalApp: data.externalApp,
          }
          : null;
      },
      enabled: !!documentId,
      retry: 0,
      ...options,
    });
